import { Injectable } from "@angular/core";
import { CacheService } from "@app/shared/utilities/cache.service";
import { Language } from "@app/shared/shared-enums";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class LanguageService {
  constructor(
    private cacheService: CacheService,
    private translate: TranslateService,
  ) {
    this.translate.use(this.lang.value);
  }

  private lang = new BehaviorSubject<string>(
    this.normalizeLanguage(localStorage.getItem("lang")),
  );

  async setLanguage(lang: string) {
    const normalizedLang = this.normalizeLanguage(lang);
    localStorage.setItem("lang", normalizedLang);
    this.translate.use(normalizedLang);
    this.lang.next(normalizedLang);
    await this.cacheService.clear();
    location.reload();
  }

  getLanguage() {
    return this.lang.value;
  }

  private normalizeLanguage(lang: string | null): string {
    return lang === Language.ar ? Language.ar : Language.en;
  }
}
